import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space['space-1600']} ${space['space-600']} ${space['space-1000']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1200']};
    gap: ${space['space-800']};
  }
`;

export const ActionBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  padding: ${space['space-300']} ${space['space-500']};
  background: ${semantic.bg.canvas};
  border-top: 1px solid ${semantic.border.subtle};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1200']};
  }
`;

export const ActionRow = styled.div`
  display: flex;
  gap: ${space['space-300']};
`;

export const ContinueButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  width: 100%;
  height: 40px;
  padding: ${space['space-100']} ${space['space-400']};
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
`;

export const RecommendationsSection = styled.div`
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding-top: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-top: ${space['space-1200']};
  }
`;

export const ContinueIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${primitives.size['size-600']};
  height: ${primitives.size['size-600']};
`;
